module.exports = __webpack_public_path__ + "assets/img/img10.d0450383.png";